<script>
import { ScTable, ScTableColumn, ScTableEmpty } from '@intelipost-js/secure-components';

export default {
  name: 'BillingExtractedFiles',
  data() {
    return {
      emptyTableTemplate: `
        <p style="font-weight: bold; font-size: 1.5em">Nenhuma fatura encontrada</p>
      `,
    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array,
      required: true,
    },
  },
  components: {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  },
};
</script>

<template>
  <sc-table
    :loading="loading" :data="files"
    :bordered="false" :hoverable="false" :striped="false" :scrollable="false">
    <template slot-scope="{ row }">
      <sc-table-column label="Arquivo" :centered="false">
        {{ row.filename }}
      </sc-table-column>
      <sc-table-column label="Fatura" :centered="false">
        {{ row.billingName }}
      </sc-table-column>
      <sc-table-column label="Solicitado em" :centered="false">
        {{ row.createdAt | date('DD/MM/YY - HH:mm') }}
      </sc-table-column>
      <sc-table-column label="Finalizado em" :centered="false">
        {{ row.finishedAt | date('DD/MM/YY - HH:mm') }}
      </sc-table-column>
      <sc-table-column label="Ações" :centered="false">
        <a class="button is-primary" :class="{'is-loading': !row.url}" :href="row.url">Download</a>
      </sc-table-column>
    </template>
    <template slot="empty">
      <sc-table-empty icon="box-open" :message="emptyTableTemplate"/>
    </template>
  </sc-table>
</template>

<style scoped lang="scss">
@import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line

td {
  color: #010906;
}

</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingExtractionsTable.vue